<template>
    <form id="withdraw" @submit.prevent="onSubmit">
    <div class="content-wrapper">
        <div class="container-lg">
            <div class="row mb-12">
                <div class="col">
                    <div class="page-title-nav row">
                        <div class="col-2 col-lg-3">
                            <router-link
                                :to="`/member/home`"
                                class="btn btn-outline-secondary btn-custom btn-back">
                                <i
                                    class="fa-icon fa-regular fa-arrow-left me-0"></i><span
                                    class="d-none d-lg-block ms-2">ย้อนกลับ</span>
                            </router-link>
                        </div>
                        <div class="col-8 col-lg-6">
                            <h1 class="page-title">ถอนเงิน</h1>
                        </div>
                        <div class="col-12 col-lg-3">
                            <a href="#" class="btn btn-primary btn-custom d-none"><i
                                    class="fa-icon fa-regular fa-home"></i><span>button</span></a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="alert alert-info d-flex" role="alert">
                                <i
                                    class="fa-icon fa-solid fa-circle-info mt-1 me-2"></i>การถอนครั้งแรกอาจจะล่าช้าเนื่องจากมีการตรวจสอบข้อมูลลูกค้า
                            </div>
                            <div class="content-card mb-4">
                                <div class="content-card-title">
                                    ถอนเงิน
                                </div>
                                <div class="content-card-body">
                                    <div
                                        class="d-flex flex-md-row flex-column align-items-center justify-content-center column-gap-4 mb-6">
                                        <div class="col-12 col-md-12 align-self-center">
                                            <div class="d-flex justify-content-center flex-row align-items-center">
                                                <img :src="imglink(myBankInfo.listBankAccount.bankName)" height="100"
                                                    width="100" id="bank2" class="detail-bank rounded-circle"
                                                    :style="'background: ' + myBankInfo.listBankAccount.bankColor" />
                                                <div class="d-flex flex-column " style="margin-left:20px">
                                                    <h6 class="text-medium m-0"> ธ. {{
                                                        myBankInfo.listBankAccount.bankName }}</h6>
                                                    <div class="d-flex flex-row">
                                                        <h4 class="text-dark m-0 me-2"> {{
                                                            myBankInfo.listBankAccount.bankNo }}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row justify-content-center">
                                        <div class="col-12 col-sm-6 col-lg-6">
                                            <label><i class="fas fa-coins"></i> จำนวนเงินที่ถอนได้</label><br />
                                            <div class="alert alert-success py-2">
                                                <h3 class="thb text-success text-center my-0 w-100"
                                                    data-id="credit_balance">{{ getBalance }}</h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row justify-content-center">
                                        <div class="col-12 col-sm-6 col-lg-6">
                                            <div class="">
                                                <label class="form-label">กรอกจำนวนเงิน</label>
                                                <div class="input-group input-group-sm input-group-merge mb-2">
                                                    <input type="tel"
                                                        class="form-control form-control-lg money-withdraw"
                                                        placeholder="ระบุเฉพาะตัวเลข" v-model.trim="$v.amount.$model" />
                                                    <span class="input-group-text">บาท</span>
                                                    <span style="cursor: pointer;" @click="setAmount"
                                                        class="text-dark input-group-text btn-warning">ทั้งหมด</span>
                                                </div>
                                                <!-- <div class="form-text mb-4">สามารถถอนเงินได้สูงสุด 10 ครั้งต่อวัน
                                                    หากมีปัญหา
                                                    กรุณาติดต่อเจ้าหน้าที่</div> -->
                                                    <strong class="text-dark d-block">ถอนเงินขั้นต่ำ <span
                                                        class="text-danger">{{ getMinWithdraw }} </span> บาท</strong>
                                                <!-- <strong class="text-dark d-block">วันนี้ถอนไปแล้วทั้งหมด <span
                                                        class="text-success">0/10</span> ครั้ง</strong>
                                                <strong class="text-dark d-block">วันนี้ถอนไปแล้วทั้งหมด <span
                                                        class="text-warning">7/10</span> ครั้ง</strong>
                                                <strong class="text-dark d-block">วันนี้ถอนไปแล้วทั้งหมด <span
                                                        class="text-danger">10/10</span> ครั้ง</strong> -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row justify-content-center ">
                                        <div class="col-12 col-sm-6 col-lg-6">
                                            <label class="mt-2"><i class="far fa-star"></i> หมายเหตุ</label>
                                                <textarea
                                                  name="note"
                                                  cols="30"
                                                  rows="2"
                                                  class="form-control"
                                                  v-model="note"
                                                  style="resize: none"
                                                ></textarea>
                                        </div>
                                    </div>
                                    <div class="row justify-content-center mt-5">
                                        <div class="col-12 col-sm-6 col-lg-6">
                                            <div class="d-grid">
                                                <button  type="submit" class="btn btn-primary"><i
                                                        class="fa-icon fa-regular fa-down-to-line"></i>ถอนเงิน</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <app-transaction />
                        </div>
                    </div>
                </div>
            </div>
            <div class="push"></div>
        </div>
    </div>
</form>
</template>
<script>
import { get, checkNumeric } from '@/utils/'
import { required } from 'vuelidate/lib/validators'
import { mapState, mapGetters, mapActions } from 'vuex'
import * as numeral from 'numeral'
import { makeTransferService } from '@/services'
import { STATUS_SUCCESS } from '@/constants'
import baac from '@/assets/banks/baac.svg'
import bay from '@/assets/banks/bay.svg'
import bbl from '@/assets/banks/bbl.svg'
import bnp from '@/assets/banks/bnp.svg'
import boa from '@/assets/banks/boa.svg'
import cacib from '@/assets/banks/cacib.svg'
import cimb from '@/assets/banks/cimb.svg'
import citi from '@/assets/banks/citi.svg'
import db from '@/assets/banks/db.svg'
import ghb from '@/assets/banks/ghb.svg'
import gsb from '@/assets/banks/gsb.svg'
import hsbc from '@/assets/banks/hsbc.svg'
import ibank from '@/assets/banks/ibank.svg'
import icbc from '@/assets/banks/icbc.svg'
import jpm from '@/assets/banks/jpm.svg'
import kbank from '@/assets/banks/kbank.svg'
import kkp from '@/assets/banks/kkp.svg'
import ktb from '@/assets/banks/ktb.svg'
import lhb from '@/assets/banks/lhb.svg'
import mb from '@/assets/banks/mb.svg'
import mega from '@/assets/banks/mega.svg'
import mufg from '@/assets/banks/mufg.svg'
import rbs from '@/assets/banks/rbs.svg'
import sc from '@/assets/banks/sc.svg'
import scb from '@/assets/banks/scb.svg'
import smbc from '@/assets/banks/smbc.svg'
// import tcap from '@/assets/banks/tcap.svg'
import tisco from '@/assets/banks/tisco.svg'
import tmb from '@/assets/banks/tmb.svg'
import uob from '@/assets/banks/uob.svg'
import ttb from '@/assets/banks/ttb.svg'
import transaction from '@/components/sakha/transaction/mainPage'
export default {
  components: {
    'app-transaction': transaction
  },
  data () {
    return {
      amount: null,
      note: '',
      imageBankMapping: {
        baac: baac,
        bay: bay,
        bbl: bbl,
        bnp: bnp,
        boa: boa,
        cacib: cacib,
        cimb: cimb,
        citi: citi,
        db: db,
        ghb: ghb,
        gsb: gsb,
        hsbc: hsbc,
        ibank: ibank,
        icbc: icbc,
        jpm: jpm,
        kbank: kbank,
        kkp: kkp,
        ktb: ktb,
        lhb: lhb,
        mb: mb,
        mega: mega,
        mufg: mufg,
        rbs: rbs,
        sc: sc,
        scb: scb,
        smbc: smbc,
        // tcap: tcap,
        tisco: tisco,
        tmb: tmb,
        uob: uob,
        ttb: ttb
      }
    }
  },
  async mounted () {
    await this.setLoading(true)
    await this.getMyAccountBanks()
    await this.setLoading(false)
  },
  computed: {
    ...mapGetters(['getBalance', 'getMinWithdraw']),
    ...mapState({
      myBankInfo: state => state.bankModule.myBankInfo
    })
  },
  watch: {
    amount: function (value) {
      if (!checkNumeric(value)) {
        this.amount = value.substring(0, value.length - 1)
      } else if (value.length === 1 && (value === '0' || value === '.')) {
        this.amount = ''
      }
    }
  },
  methods: {
    ...mapActions(['getMyAccountBanks', 'setLoading', 'openInfoPopup', 'setCreditTurn']),
    setAmount () {
      this.amount = numeral(this.getBalance)._value
    },
    async onSubmit () {
      await this.setLoading(true)
      try {
        const resp = await makeTransferService(this.amount, this.note)
        if (resp.status_code === STATUS_SUCCESS) {
          this.$router.replace('/member')
          this.openInfoPopup()
        } else if (resp.status_code === 714) {
          this.setCreditTurn(resp.status_msg)
          console.log(resp.status_msg)
          this.$router.replace('unavailablewithdraw')
        }
      } catch (error) { }
      await this.setLoading(false)
    },
    imglink (short) {
      return get(this.imageBankMapping, [short])
    }
  },
  validations () {
    return {
      amount: {
        required
      }
    }
  }
}
</script>
